/**
 * Palette für Touren.
 *
 * Aus ihr vergeben Dashboard und Planungsassistent die Farben nach Index, die
 * Benutzer-Masken bieten sie als Schnellauswahl für die feste Tourfarbe an
 * (users.tour_color), und die Planungs-Szenarien färben ihre Wochentage damit
 * ein — Reihenfolge dort: Montag bis Sonntag. Deshalb liegt sie hier und nicht
 * beim Planungsassistenten: die Szenarien dürfen von dort nichts importieren.
 */
export const TOUR_COLORS = [
  '#53aae8', // hellblau
  '#8451ec', // violett
  '#f032e6', // magenta
  '#e81416', // rot
  '#ffa500', // orange
  '#55a106', // grün
  '#019579', // türkis
];

/**
 * Farbpalette für Dispatcher (15 Farben mit guter Lesbarkeit).
 *
 * Wird zweifach genutzt: das Dashboard vergibt daraus die Farben nach Index,
 * die Benutzer-Bearbeitung bietet sie als Schnellauswahl an. Eine am Benutzer
 * gesetzte Farbe (users.dispatcher_color) schlägt die Index-Farbe.
 */
export const DISPATCHER_COLORS = [
  '#FF6B6B', // Rot
  '#4ECDC4', // Türkis
  '#45B7D1', // Blau
  '#FFA07A', // Lachs
  '#98D8C8', // Mint
  '#F7DC6F', // Gelb
  '#BB8FCE', // Lila
  '#85C1E2', // Hellblau
  '#F8B88B', // Orange
  '#A3E4D7', // Aqua
  '#FAD7A0', // Beige
  '#D7BDE2', // Lavendel
  '#A9DFBF', // Hellgrün
  '#F9E79F', // Hellgelb
  '#FADBD8', // Rosa
];
